// Student success stories — sample data mirrors the existing Lincoln site
// pattern. Each entry renders a colored card with name, sessions, topic, and
// a before/after improvement chart.

export const STUDENTS = [
  { name: 'Salaar Ali',  sessions: 2, topic: 'Math word problems', before: 45, after: 80,  bg: '#f0b80c', accent: 'dark'  },
  { name: 'Rania',       sessions: 2, topic: 'Addition',           before: 48, after: 70,  bg: '#7a3a8a', accent: 'light' },
  { name: 'Naail Ahmed', sessions: 1, topic: 'Nouns',              before: 47, after: 100, bg: '#5b3a8a', accent: 'light' },
  { name: 'Hannan',      sessions: 3, topic: 'Sentence structure', before: 37, after: 95,  bg: '#0e1f36', accent: 'light' },
  { name: 'Abdullah',    sessions: 2, topic: 'Possessive nouns',   before: 28, after: 83,  bg: '#2b6cd9', accent: 'light' },
  { name: 'Azlaan',      sessions: 2, topic: 'Place value',        before: 30, after: 100, bg: '#c97864', accent: 'light' },
  { name: 'Neetu',       sessions: 2, topic: '2D figures',         before: 18, after: 87,  bg: '#8a3a6a', accent: 'light' },
  { name: 'Arman',       sessions: 3, topic: 'Area & perimeter',   before: 44, after: 75,  bg: '#1e7a6a', accent: 'light' },
];
